import {PageElementMetadataRestDto} from "@/api/pharma-cms-content-page/models";
import {StatusEnum} from "@/api/enums/status-enum";
import i18n from "@/modules/i18n";

function getDescriptionVisibilityRuleStatus(metadata: PageElementMetadataRestDto): string {
    return `${(metadata?.status?.code === StatusEnum.PUBLISHED)
        ? i18n.global.t('visible')
        : i18n.global.t('notVisible')} (${metadata.visibility_rule_type?.description})`;
}

export {getDescriptionVisibilityRuleStatus}
